import { render, staticRenderFns } from "./NoticeMas.vue?vue&type=template&id=59a19657&scoped=true"
import script from "./NoticeMas.vue?vue&type=script&lang=js"
export * from "./NoticeMas.vue?vue&type=script&lang=js"
import style0 from "./NoticeMas.vue?vue&type=style&index=0&id=59a19657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a19657",
  null
  
)

export default component.exports